import React from "react";
import EmailInput from "Source/components/project/Common/Form/EmailInput/EmailInput";
import { EMAIL_SUFFIX } from "Source/components/project/Config/Config";

class AccountEmailInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isHovered: false,
        }
    }

    render() {
        const { fieldEmailProps } = this.props;
        const { valid, errorMessage } = fieldEmailProps;
        const classes = !valid ? 'hasError' : '';

        return  <div class="emailFormContainer">
            <div class={`emailInputContainer ${classes}`}>
                <EmailInput
                    name="email"
                    label="Account Email"
                    placeholder="Account Email"
                    {...fieldEmailProps}
                />
                <span>@{EMAIL_SUFFIX}</span>
            </div>

            {errorMessage && !valid
                && <span class="errorMsg">{errorMessage}</span>
            }
        </div>
    }
}

export default AccountEmailInput;